import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';



// Apenas o EasyMove será destaque como produto principal
const product = {
  id: 1,
  name: "EasyMove",
  tagline: "Gestão Inteligente de Estoque",
  description: "Revolucione sua gestão de estoque com integração total ao TOTVS Protheus, sincronização automática e operações 60% mais rápidas.",
  features: [
    "Integração Total com TOTVS Protheus",
    "Sincronização Automática de Dados",
    "Interface Intuitiva e Customizável",
    "Segurança e Confiabilidade",
    "Suporte Dedicado e Treinamento",
  ],
  path: "/products/EasyMove"
};

// Produtos em breve
const comingSoonProducts = [
  {
    id: 2,
    name: "Precisifier",
    tagline: " Precificador Inteligente",
    description: "Automatize sua precificação com nossa ferramenta que analisa e sugere preços ideais para seus produtos.",
    path: "/products/coming-soon"
  },
  {
    id: 3,
    name: "FiscalAnalyzer",
    tagline: "Análise Fiscal Automatizada",
    description: "Simplifique sua conformidade fiscal com nossa solução que analisa e gera relatórios automaticamente.",
  }
];

const ProductsPage = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      {/* Hero Section */}
      <HeroSection>
        {/* Abstract Decorations */}
        <HeroDecorations>
          <BlurCircle position="top-left" size="24rem" color="rgba(96, 165, 250, 0.2)" blur="50px" />
          <BlurCircle position="bottom-right" size="32rem" color="rgba(103, 232, 249, 0.1)" blur="60px" />
          <BlurCircle position="top-right" size="16rem" color="rgba(59, 130, 246, 0.2)" blur="40px" />
        </HeroDecorations>

        <HeroContent>
          <HeroTitle>
            Tecnologia que <GradientText>Transforma</GradientText> Processos
          </HeroTitle>
          <HeroSubtitle>
            Desenvolvemos soluções inovadoras que automatizam e otimizam seus processos, 
            tornando sua operação mais eficiente e seus resultados mais expressivos.
          </HeroSubtitle>
        </HeroContent>
      </HeroSection>

      {/* Seção Sobre Nossa Abordagem */}
      <SectionContainer>
        <SectionTitle>
          <SectionTitleText>Nossa Abordagem</SectionTitleText>
          <TitleUnderline />
        </SectionTitle>
        
        <ApproachText>
          Buscamos constantemente desenvolver produtos inovadores que solucionam problemas reais das empresas.
          Nossa missão é criar tecnologias que automatizam processos complexos e tornam sua operação 
          significativamente mais eficiente, permitindo que você foque no que realmente importa: o crescimento do seu negócio.
        </ApproachText>
        
        <ApproachGrid>
          <ApproachCard>
            <ApproachIcon>🔍</ApproachIcon>
            <ApproachCardTitle>Análise Personalizada</ApproachCardTitle>
            <ApproachCardText>
              Entendemos profundamente seu negócio para desenvolver soluções que se adaptam perfeitamente às suas necessidades.
            </ApproachCardText>
          </ApproachCard>
          
          <ApproachCard>
            <ApproachIcon>⚙️</ApproachIcon>
            <ApproachCardTitle>Automação Inteligente</ApproachCardTitle>
            <ApproachCardText>
              Automatizamos processos repetitivos e complexos, reduzindo erros e aumentando a produtividade da sua equipe.
            </ApproachCardText>
          </ApproachCard>
          
          <ApproachCard>
            <ApproachIcon>📊</ApproachIcon>
            <ApproachCardTitle>Insights Acionáveis</ApproachCardTitle>
            <ApproachCardText>
              Transformamos dados em informações valiosas que permitem decisões mais estratégicas e precisas.
            </ApproachCardText>
          </ApproachCard>
        </ApproachGrid>
      </SectionContainer>

      {/* Produto Principal Section */}
      <SectionContainer>
        <SectionTitle>
          <SectionTitleText>Nossa Solução Principal</SectionTitleText>
          <TitleUnderline />
        </SectionTitle>

        <FeaturedProductWrapper>
          <FeaturedProductCard onClick={() => navigate(product.path)}>
            <ColorBorder />
            <NewBadge>Destaque</NewBadge>

            <ProductIcon>{product.name.charAt(0)}</ProductIcon>

            <ProductName>{product.name}</ProductName>
            <ProductTagline>{product.tagline}</ProductTagline>
            
            <ProductDescription>
              {product.description}
            </ProductDescription>
            
            <Divider />
            
            <FeatureList>
              {product.features.map((feature, idx) => (
                <FeatureItem key={idx}>
                  <FeatureCheck>✓</FeatureCheck>
                  <FeatureText>{feature}</FeatureText>
                </FeatureItem>
              ))}
            </FeatureList>
            
            <ActionButton>
              Ver Detalhes
              <ButtonArrow>→</ButtonArrow>
            </ActionButton>
          </FeaturedProductCard>
          
          <FeaturedProductContent>
            <FeaturedProductTitle>EasyMove</FeaturedProductTitle>
            <FeaturedProductSubtitle>Transforme sua gestão de estoque</FeaturedProductSubtitle>
            <FeaturedProductDescription>
              O EasyMove é nossa solução principal para gestão de estoque, 
              desenvolvida para integrar perfeitamente com o TOTVS Protheus e 
              outros ERPs. Com interface intuitiva e sincronização automática, 
              nossos clientes relatam operações até 60% mais rápidas e redução 
              significativa de erros de inventário.
            </FeaturedProductDescription>
            <BenefitsList>
              <BenefitItem>
                <BenefitIcon>⏱️</BenefitIcon>
                <BenefitText>Redução de 60% no tempo de operação</BenefitText>
              </BenefitItem>
              <BenefitItem>
                <BenefitIcon>📊</BenefitIcon>
                <BenefitText>99.8% de precisão no controle de estoque</BenefitText>
              </BenefitItem>
              <BenefitItem>
                <BenefitIcon>💰</BenefitIcon>
                <BenefitText>Economia de até 30% em custos operacionais</BenefitText>
              </BenefitItem>
            </BenefitsList>
          </FeaturedProductContent>
        </FeaturedProductWrapper>
      </SectionContainer>

      {/* Coming Soon Products Section */}
      <ComingSoonSection>
        <HeroDecorations>
          <BlurCircle position="left-center" size="24rem" color="rgba(96, 165, 250, 0.05)" blur="50px" />
          <BlurCircle position="right-bottom" size="18rem" color="rgba(103, 232, 249, 0.05)" blur="40px" />
        </HeroDecorations>
        
        <SectionContainer>
          <SectionTitle>
            <SectionTitleText style={{ color: 'white' }}>Em Breve Novidades</SectionTitleText>
            <TitleUnderline />
          </SectionTitle>

          <ComingSoonGrid>
            {comingSoonProducts.map((product) => (
              <ComingSoonCard key={product.id}>
                <ComingSoonIcon>{product.name.charAt(0)}</ComingSoonIcon>
                <ComingSoonName>{product.name}</ComingSoonName>
                <ComingSoonTagline>{product.tagline}</ComingSoonTagline>
                <ComingSoonDescription>{product.description}</ComingSoonDescription>
                <ComingBadge>Em breve</ComingBadge>
                <NotifyButton as="a" href="https://wa.me/553498055971" target="_blank" rel="noopener noreferrer">
                  Quero ser avisado
                </NotifyButton>
              </ComingSoonCard>
            ))}
          </ComingSoonGrid>
        </SectionContainer>
      </ComingSoonSection>

      {/* CTA Section */}
      <CTASection>
        <HeroDecorations>
          <BlurCircle position="left-center" size="24rem" color="rgba(96, 165, 250, 0.1)" blur="50px" />
          <BlurCircle position="right-bottom" size="18rem" color="rgba(103, 232, 249, 0.1)" blur="40px" />
        </HeroDecorations>
        
        <CTAContent>
          <CTATitle>Pronto para revolucionar seus processos empresariais?</CTATitle>
          <CTAText>
            Entre em contato hoje mesmo e descubra como nossas soluções podem automatizar processos e
            aumentar a eficiência operacional do seu negócio.
          </CTAText>
            <CTAButton as="a" href="https://wa.me/553498055971" target="_blank" rel="noopener noreferrer">
            Agendar Demonstração
            </CTAButton>
        </CTAContent>
      </CTASection>
    </PageContainer>
  );
};

// Base Styles
const PageContainer = styled.div`
  max-height: 70%;
  background: linear-gradient(to bottom, #f8fafc, #f1f5f9);
  font-family: 'Inter', 'Segoe UI', Roboto, sans-serif;
`;

// Hero Section
const HeroSection = styled.section`
  position: relative;
  padding: 5rem 2rem 6rem;
  background: radial-gradient(circle, rgba(4,16,22,1) 0%, rgba(4,44,64,1) 100%);
  color: white;
  overflow: hidden;
  
  @media (min-width: 1024px) {
    padding: 6rem 2rem 8rem;
  }
`;

const HeroDecorations = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.2;
`;

interface BlurCircleProps {
  position: string;
  size: string;
  color: string;
  blur: string;
}

const BlurCircle = styled.div<BlurCircleProps>`
  position: absolute;
  border-radius: 50%;
  background: ${props => props.color};
  width: ${props => props.size};
  height: ${props => props.size};
  filter: blur(${props => props.blur});
  
  ${props => {
    switch(props.position) {
      case 'top-left':
        return `top: 5%; left: 10%;`;
      case 'top-right':
        return `top: 10%; right: 15%;`;
      case 'bottom-right':
        return `bottom: 5%; right: 20%;`;
      case 'left-center':
        return `top: 40%; left: 0;`;
      case 'right-bottom':
        return `bottom: 10%; right: 10%;`;
      default:
        return '';
    }
  }}
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
`;

const HeroTitle = styled.h1`
margin-top: 5rem;
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  
  @media (min-width: 640px) {
    font-size: 3.5rem;
  }
  
  @media (min-width: 1024px) {
    font-size: 4rem;
  }
`;

const GradientText = styled.span`
  background: linear-gradient(to right, #bfdbfe, #7dd3fc);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

const HeroSubtitle = styled.p`
  font-size: 1.125rem;
  max-width: 36rem;
  margin: 0 auto 2.5rem;
  color: rgba(255, 255, 255, 0.9);
  
  @media (min-width: 640px) {
    font-size: 1.25rem;
    max-width: 42rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`;

const PrimaryButton = styled.button`
  background: linear-gradient(to right, #38bdf8, #2563eb);
  color: white;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: 0 4px 6px rgba(56, 189, 248, 0.2);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(56, 189, 248, 0.3);
  }
`;

const SecondaryButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: transform 0.3s, background 0.3s;
  backdrop-filter: blur(4px);
  
  &:hover {
    transform: translateY(-3px);
    background: rgba(255, 255, 255, 0.2);
  }
`;

// Section Container
const SectionContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 5rem 2rem;
  
  @media (min-width: 1024px) {
    padding: 6rem 2rem;
  }
`;

// Section Title
const SectionTitle = styled.h2`
  position: relative;
  text-align: center;
  margin-bottom: 4rem;
`;

const SectionTitleText = styled.span`
  color: #003554;
  font-size: 2rem;
  font-weight: 700;
  
  @media (min-width: 640px) {
    font-size: 2.5rem;
  }
`;

const TitleUnderline = styled.span`
  position: absolute;
  height: 4px;
  width: 6rem;
  background: linear-gradient(to right, #38bdf8, #2563eb);
  bottom: -1rem;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
`;

// Approach Section
const ApproachText = styled.p`
  text-align: center;
  max-width: 48rem;
  margin: 0 auto 3rem;
  font-size: 1.125rem;
  color: #475569;
  line-height: 1.8;
`;

const ApproachGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const ApproachCard = styled.div`
  background: white;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.3s;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const ApproachIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1rem;
`;

const ApproachCardTitle = styled.h3`
  color: #003554;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const ApproachCardText = styled.p`
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.6;
`;

// Featured Product
const FeaturedProductWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    align-items: center;
  }
`;

const FeaturedProductCard = styled.div`
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s, box-shadow 0.3s;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1);
  }
`;

const FeaturedProductContent = styled.div`
  padding: 1rem;
`;

const FeaturedProductTitle = styled.h3`
  color: #003554;
  font-size: 2.25rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
`;

const FeaturedProductSubtitle = styled.p`
  color: #38bdf8;
  font-size: 1.25rem;
  font-weight: 500;
  margin: 0 0 1.5rem;
`;

const FeaturedProductDescription = styled.p`
  color: #475569;
  font-size: 1.125rem;
  line-height: 1.7;
  margin-bottom: 2rem;
`;

const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 2rem;
`;

const BenefitItem = styled.li`
  display: flex;
  align-items: center;
  padding: 0.75rem 0;
`;

const BenefitIcon = styled.span`
  font-size: 1.25rem;
  margin-right: 1rem;
`;

const BenefitText = styled.span`
  color: #334155;
  font-size: 1.1rem;
`;

const LearnMoreButton = styled.button`
  background: transparent;
  color: #003554;
  font-weight: 600;
  border: 2px solid #003554;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background: #003554;
    color: white;
  }
`;

const ColorBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(to right, #38bdf8, #2563eb);
`;

const NewBadge = styled.span`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: linear-gradient(to right, #38bdf8, #2563eb);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  box-shadow: 0 2px 4px rgba(56, 189, 248, 0.2);
`;

const ProductIcon = styled.div`
  width: 3rem;
  height: 3rem;
  background: linear-gradient(135deg, #003554, #003554);
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;
`;

const ProductName = styled.h3`
  color: #003554;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
`;

const ProductTagline = styled.p`
  color: #475569;
  font-size: 1rem;
  margin: 0;
`;

const ProductDescription = styled.p`
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-top: 1rem;
`;

const Divider = styled.div`
  height: 1px;
  background: #e2e8f0;
  margin: 1.5rem 0;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 2rem;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  padding: 0.5rem 0;
`;

const FeatureCheck = styled.span`
  color: #38bdf8;
  margin-right: 0.75rem;
  font-weight: bold;
`;

const FeatureText = styled.span`
  color: #64748b;
  font-size: 0.95rem;
`;

const ActionButton = styled.button`
  background: linear-gradient(to right, #003554, #003554);
  color: white;
  font-weight: 500;
  width: 100%;
  padding: 0.75rem 0;
  border-radius: 0.5rem;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(30, 58, 138, 0.2);
  }
`;

const ButtonArrow = styled.span`
  margin-left: 0.5rem;
  transition: transform 0.2s;
  
  ${ActionButton}:hover & {
    transform: translateX(4px);
  }

  ${LearnMoreButton}:hover & {
    transform: translateX(4px);
  }
`;

// Coming Soon Section
const ComingSoonSection = styled.section`
  background: linear-gradient(135deg, #003554 0%, #003554 100%);
  position: relative;
  overflow: hidden;
  color: white;
`;

const ComingSoonGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const ComingSoonCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 1rem;
  padding: 2rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  transition: transform 0.3s;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const ComingSoonIcon = styled.div`
  width: 3rem;
  height: 3rem;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;
`;

const ComingSoonName = styled.h3`
  color: white;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
`;

const ComingSoonTagline = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  margin: 0 0 1rem;
`;

const ComingSoonDescription = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const ComingBadge = styled.span`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
`;

const NotifyButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-weight: 500;
  width: 100%;
  padding: 0.75rem 0;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

// CTA Section
const CTASection = styled.section`
  background: linear-gradient(135deg, #003554 0%, #003554 100%);
  padding: 5rem 2rem;
  position: relative;
  overflow: hidden;
  
  @media (min-width: 1024px) {
    padding: 6rem 2rem;
  }
`;

const CTAContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 48rem;
  margin: 0 auto;
  text-align: center;
  color: white;
`;

const CTATitle = styled.h2`
  Color:rgb(178, 237, 255);
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 1.5rem;
  
  @media (min-width: 640px) {
    font-size: 2.5rem;
  }
`;

const CTAText = styled.p`
  font-size: 1.125rem;
  opacity: 0.9;
  max-width: 36rem;
  margin: 0 auto 2rem;
`;

const CTAButton = styled.button`
  background: linear-gradient(to right, #38bdf8, #2563eb);
  color: white;
  font-weight: 600;
  font-size: 1.125rem;
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: 0 4px 6px rgba(56, 189, 248, 0.2);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 15px rgba(56, 189, 248, 0.3);
  }
`;

export default ProductsPage;